import React, { useEffect, useState } from 'react'
import Header from '../../layouts/Header'
import { Button, Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import Select from "react-select";
import { toast } from 'react-toastify';
import axiosInstance from '../../api/axios';import { TagsInput } from 'react-tag-input-component';
import makeAnimated from "react-select/animated";

const AddMenu = () => {

  const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  const accessToken = localStorage.getItem('authToken');
  const [isLoading, setIsLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [inputData, setInputData] = useState({
    sequenceNumber: "",
    category: "",
    name: "",
    description: "",
    hsn: "",
    taxPercent: "",
    makingTime: "",
    mrp: "",
    offerPrice: "",
    productCost: 0,
    productTagId: "",
    productTagName: "",
    keywords: [],
    foodType: "",
    classType: "",
    calories: "",
    weight: "",
    weightUnit: "",
    isEventProduct: "",
    isNewProduct: "",
    isFreebieProduct: "", // Added new field
    orderType: "ALL"
  });
  const [productTags, setProductTags] = useState([]);
  const [isSelected, setIsSelected] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [image, setImage] = useState(null);
  const [outlets, setOutlets] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [selectedExcludedOutlets, setSelectedExcludedOutlets] = useState([]);
  const animatedComponents = makeAnimated();
  const [coverImage, setCoverImage] = useState('');
  const [selectedNature, setSelectedNature] = useState([]);

  const outletData = outlets.map((outlet) => ({
    value: outlet._id,
    label: `${outlet.name} (${outlet.city})${outlet.status === "COMING_SOON" || outlet.status === "INACTIVE"
        ? ` - ${outlet.status.replace("_", " ")}`
        : ""
      }`,
  }));

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      borderRadius: "6px",
      minWidth: "200px",
      borderColor: state.isFocused ? "#80bdff" : "#ced4da",
      boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
      "&:hover": {
        borderColor: state.isFocused ? "#80bdff" : "#ced4da",
      },
      fontSize: "0.85rem", // Smaller font size for select input
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#6c757d",
      fontSize: "0.85rem", // Smaller placeholder
    }),
    option: (provided) => ({
      ...provided,
      fontSize: "0.85rem", // Smaller option text
    }),
    multiValue: (provided) => ({
      ...provided,
      fontSize: "0.85rem", // Smaller multi-value text
    }),
    input: (provided) => ({
      ...provided,
      fontSize: "0.85rem", // Smaller input text
    }),
  };

  const getCategoryList = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axiosInstance.get("masters/category/get", { headers });
      console.log("Response :", response);

      if (response?.data?.status === true) {
        console.log("Categories Data:", response?.data?.data?.categories);
        const categories = response?.data?.data?.categories;
        setCategoryList(categories);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    }
  };

  const getProductTags = async (text) => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axiosInstance.get(`/product/tags?search=${text}`, { headers });

      if (response?.data?.status === true) {
        setIsSelected(true)
        setProductTags(response?.data?.data?.productTags);
      } else {
        setProductTags([])
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    }
  };

  const getOutlets = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axiosInstance.get("outlet", { headers });

      if (response?.data?.status === true) {

        // let filteredOutlets = response?.data?.data?.outlets?.filter((act) => act?.status === "ACTIVE");

        setOutlets(response?.data?.data?.outlets);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData((prevState) => {
      if (name === "productTagId") {
        const selectedTag = productTags?.find((tag) => tag?._id === value);
        return {
          ...prevState,
          [name]: value,
          productTagName: selectedTag ? selectedTag?.tagName : "",
        };
      }
      return { ...prevState, [name]: value };
    });
  };

  const handleSearchText = (e) => {
    setSearchText(e.target.value)
    setInputData((prev) => ({ ...prev, productTagName: e.target.value }))
  };

  const handleOptionSelect = (selectedOption, selectedName) => {
    setInputData((prev) => ({ ...prev, productTagName: selectedName, productTagId: selectedOption }));
    setProductTags([]);
  };

  const handleSelectChange = async (selected) => {
    setSelectedExcludedOutlets(selected);
  };

  const handleImageChange = (e) => {
    const input = document.getElementById("imageInput");

    const file = input?.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const image = new Image();
        image.src = reader.result;

        image.onload = () => {
          const width = image.width;
          const height = image.height;

          const maxWidth = 400;
          const maxHeight = 400;

          if (width === maxWidth && height === maxHeight) {
            // alert("Image dimensions are valid!");
            setImage(file);
          } else {
            alert(
              "Image dimensions are not valid. Please choose an image with dimensions equal to " +
              maxWidth +
              "x" +
              maxHeight
            );
            input.value = "";
          }
        };
      };

      reader.readAsDataURL(file);
    }
  };

  const handleCoverImageChange = () => {
    const input = document.getElementById("coverImageInput");

    const file = input?.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const image = new Image();
        image.src = reader.result;
        setCoverImage(file);

        // image.onload = () => {
        //   const width = image.width;
        //   const height = image.height;

        //   const maxWidth = 400;
        //   const maxHeight = 400;

        //   if (width === maxWidth && height === maxHeight) {
        //     alert("Image dimensions are valid!");
        //     setCoverImage(file);
        //   } else {
        //     alert(
        //       "Image dimensions are not valid. Please choose an image with dimensions equal to " +
        //       maxWidth +
        //       "x" +
        //       maxHeight
        //     );
        //     input.value = "";
        //   }
        // };
      };

      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const formData = new FormData();
      let _prodKeywords;
      if (selected.length > 0) {
        const _selectedodified = selected.map(val => val.trim());
        _prodKeywords = _selectedodified.join(',');
      }
      else {
        toast.error("Product keywords is required", {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
        return;
      }

      let selectOutlets = selectedExcludedOutlets.map((val) => val?.value);
      console.log("Selected Outlets :", selectOutlets);

      let newInputData = {
        ...inputData,
        excludedOutlets: selectOutlets
      }

      // if (image) {
      formData.append("displayImage", image);
      // }
      // if (coverImage) {
      formData.append("coverPicture", coverImage);
      // }
      formData.append("sequenceNumber", newInputData.sequenceNumber);
      formData.append("category", newInputData.category);
      formData.append("name", newInputData.name);
      formData.append("description", newInputData.description);
      formData.append("hsn", newInputData.hsn);
      formData.append("taxPercent", newInputData.taxPercent);
      if (newInputData?.makingTime) {
        formData.append("makingTime", newInputData.makingTime);
      }
      formData.append("mrp", newInputData.mrp);
      formData.append("offerPrice", newInputData.offerPrice);
      formData.append("isEventProduct", newInputData.isEventProduct);
      formData.append("isFreebieProduct", newInputData.isFreebieProduct); // Added new field
      formData.append("orderType", newInputData.orderType);
      formData.append("keywords", _prodKeywords);
      if (newInputData?.productTagId) {
        formData.append("productTag[productTagId]", newInputData.productTagId);
      }
      formData.append("productTag[productTagName]", newInputData.productTagName);
      formData.append("foodType", newInputData.foodType);
      formData.append("classType", newInputData.classType);
      formData.append("calories", newInputData.calories);
      formData.append("weight", newInputData.weight);
      formData.append("weightUnit", newInputData.weightUnit);
      formData.append("isNewProduct", newInputData.isNewProduct);
      formData.append("productCost", newInputData.productCost);

      // Append each excluded outlet as excludedOutlets[0], excludedOutlets[1], etc.
      if (selectOutlets?.length > 0) {
        selectOutlets.forEach((outlet, index) => {
          formData.append(`excludedOutlets[${index}]`, outlet);
        });
      }

      // Append each excluded outlet as excludedOutlets[0], excludedOutlets[1], etc.
      if (selectedNature?.length > 0) {
        selectedNature?.forEach((nature, index) => {
          formData.append(`productsNature[${index}]`, nature);
        });
      }

      // Debugging: log the formData content
      for (let pair of formData.entries()) {
        console.log(`${pair[0]}: ${pair[1]}`);
      }

      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${accessToken}`,
      };

      const response = await axiosInstance.post("product", formData, { headers });

      if (response?.data?.status === true) {
        toast.success(response?.data?.data?.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });

        e.target.reset();

        setInputData({
          sequenceNumber: "",
          category: "",
          name: "",
          description: "",
          hsn: "",
          taxPercent: "",
          makingTime: "",
          mrp: "",
          offerPrice: "",
          hasAddon: "",
          status: "",
          classType: "",
          isEventProduct: "",
          isNewProduct: "",
          isFreebieProduct: "", // Added new field
          productCost: "",
          orderType: "ALL"
        });
        setSelected([]);
        setSelectedExcludedOutlets([]);
        const input = document.getElementById("imageInput");
        input.value = "";
        setImage("");
      }
    } catch (error) {
      console.log("error :'", error);

      if (error?.response) {
        let errorMessage = '';
        if (error.response?.status === 406) {
          errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
        }
        else if (error.response?.status === 412) {
          errorMessage = error?.response?.data?.data?.message;
        } else if (error.response?.status === 400) {
          errorMessage = error?.response?.data?.error;
        } else if (error.response?.status === 500) {
          errorMessage = error?.response?.data?.message;
        } else if (error.response?.status === 500) {
          errorMessage = error?.response?.data?.error
        }

        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getCategoryList();
    getOutlets();
  }, []);

  useEffect(() => {
    getProductTags(searchText);
  }, [searchText]);

  // Inline styles for smaller fonts
  const styles = {
    formLabel: {
      fontSize: '0.85rem',
      marginBottom: '0.25rem',
    },
    formControl: {
      fontSize: '0.85rem',
    },
    heading: {
      fontSize: '1.1rem',
    },
    helperText: {
      fontSize: '0.75rem',
      color: 'purple',
    },
    button: {
      fontSize: '0.85rem',
    },
    dropdownItem: {
      padding: '5px',
      cursor: 'pointer',
      fontSize: '0.85rem',
    }
  };

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <div className="container shadow-sm" style={{ backgroundColor: "white" }}>
          <Row className="pt-4">
            <Col>
              <h5 className="fw-semibold" style={styles.heading}>ADD MENU</h5>
            </Col>
            <hr />
          </Row>
          <Form onSubmit={handleSubmit}>
            <Row className="gy-3">
              {/* Sequence Number */}
              <Col md={4} lg={3}>
                <Form.Group>
                  <Form.Label style={styles.formLabel}>
                    Sequence Number <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Sequence Number"
                    name="sequenceNumber"
                    value={inputData.sequenceNumber || ""}
                    onChange={handleChange}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Select Category */}
              <Col md={4} lg={3}>
                <Form.Group>
                  <Form.Label style={styles.formLabel}>
                    Select Category <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    name="category"
                    value={inputData.category || ""}
                    onChange={handleChange}
                    style={styles.formControl}
                  >
                    <option value="">Select Category</option>
                    {categoryList?.map((category) => (
                      <option key={category?._id} value={category?._id}>
                        {category?.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              {/* Name */}
              <Col md={4} lg={3}>
                <Form.Group>
                  <Form.Label style={styles.formLabel}>
                    Menu Name <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Name"
                    name="name"
                    value={inputData.name || ""}
                    onChange={handleChange}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Class Type */}
              <Col md={6} lg={3}>
                <Form.Group>
                  <Form.Label style={styles.formLabel}>
                    Class Type <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    name="classType"
                    value={inputData.classType || ""}
                    onChange={handleChange}
                    style={styles.formControl}
                  >
                    <option value="">Class Type</option>
                    <option value="FOOD">FOOD</option>
                    <option value="BEVERAGE">BEVERAGE</option>
                    <option value="COMBOS">COMBOS</option>
                    <option value="DESSERTS">DESSERTS</option>
                    <option value="EXTRAS">EXTRAS</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              {/* Food Type */}
              <Col md={6} lg={3}>
                <Form.Group>
                  <Form.Label style={styles.formLabel}>
                    Food Type <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    name="foodType"
                    value={inputData.foodType || ""}
                    onChange={handleChange}
                    style={styles.formControl}
                  >
                    <option value="">Food Type</option>
                    <option value="VEG">VEG</option>
                    <option value="NON-VEG">NON-VEG</option>
                    <option value="VEGAN">VEGAN</option>
                    <option value="VEG/VEGAN">VEG/VEGAN</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              {/* HSN */}
              <Col md={4} lg={3}>
                <Form.Group>
                  <Form.Label style={styles.formLabel}>
                    HSN <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="HSN"
                    name="hsn"
                    value={inputData.hsn || ""}
                    onChange={handleChange}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Weight Unit */}
              <Col md={4} lg={3}>
                <Form.Group>
                  <Form.Label style={styles.formLabel}>
                    Weight Unit <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    name="weightUnit"
                    value={inputData.weightUnit || ""}
                    onChange={handleChange}
                    style={styles.formControl}
                  >
                    <option value="">Weight Unit</option>
                    <option value="KG">KILOGRAMS</option>
                    <option value="GMS">GRAMS</option>
                    <option value="LITRES">LITRES</option>
                    <option value="ML">MILLI-LITRE</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              {/* Weight */}
              <Col md={4} lg={3}>
                <Form.Group>
                  <Form.Label style={styles.formLabel}>
                    Weight <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Weight"
                    name="weight"
                    step="any"
                    value={inputData.weight || ""}
                    onChange={handleChange}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Calories */}
              <Col md={4} lg={3}>
                <Form.Group>
                  <Form.Label style={styles.formLabel}>
                    Calories <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Calories"
                    name="calories"
                    step="any"
                    value={inputData.calories || ""}
                    onChange={handleChange}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Tax Percent */}
              <Col md={4} lg={3}>
                <Form.Group>
                  <Form.Label style={styles.formLabel}>
                    Tax Percent <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Tax Percent"
                    name="taxPercent"
                    step="any"
                    value={inputData.taxPercent || ""}
                    onChange={handleChange}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              <Col md={3} lg={3}>
                <Form.Group>
                  <Form.Label style={styles.formLabel}>
                    Order Type <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    name="orderType"
                    value={inputData.orderType || ""}
                    onChange={handleChange}
                    style={styles.formControl}
                  >
                    <option value="ALL">ALL</option>
                    <option value="DELIVERY">DELIVERY</option>
                    <option value="PICKUP">PICK-UP</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              {/* Making Time */}
              <Col md={4} lg={3}>
                <Form.Group>
                  <Form.Label style={styles.formLabel}>
                    Making Time <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Making Time (mins)"
                    name="makingTime"
                    step="any"
                    value={inputData.makingTime || ""}
                    onChange={handleChange}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* MRP */}
              <Col md={4} lg={2}>
                <Form.Group>
                  <Form.Label style={styles.formLabel}>
                    MRP <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="MRP (₹)"
                    name="mrp"
                    step="any"
                    value={inputData.mrp || ""}
                    onChange={handleChange}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Offer Price */}
              <Col md={4} lg={2}>
                <Form.Group>
                  <Form.Label style={styles.formLabel}>
                    Offer Price <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Offer Price (₹)"
                    name="offerPrice"
                    step="any"
                    value={inputData.offerPrice || ""}
                    onChange={handleChange}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              <Col md={4} lg={2}>
                <Form.Group>
                  <Form.Label style={styles.formLabel}>
                    Product Costing
                  </Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Product Costing (₹)"
                    name="productCost"
                    step="any"
                    value={inputData.productCost}
                    onChange={handleChange}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Image Upload */}
              <Col md={12} lg={3}>
                <Form.Group>
                  <Form.Label style={styles.formLabel}>
                    Choose Menu Image <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    id="imageInput"
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Cover Image Upload */}
              <Col md={12} lg={3}>
                <Form.Group>
                  <Form.Label style={styles.formLabel}>
                    Choose Cover Image
                  </Form.Label>
                  <Form.Control
                    id="coverImageInput"
                    type="file"
                    accept="image/*"
                    onChange={handleCoverImageChange}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Is Freebie Product */}
              <Col md={2} lg={3}>
                <Form.Group>
                  <Form.Label style={styles.formLabel}>
                    Make This Freebie Product <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    name="isFreebieProduct"
                    value={inputData.isFreebieProduct || ""}
                    onChange={handleChange}
                    style={styles.formControl}
                  >
                    <option value="">Select</option>
                    <option value="true">YES</option>
                    <option value="false">NO</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              {/* Is Product Event */}
              <Col md={2} lg={3}>
                <Form.Group>
                  <Form.Label style={styles.formLabel}>
                    Enable New Badge <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    name="isNewProduct"
                    value={inputData.isNewProduct || ""}
                    onChange={handleChange}
                    style={styles.formControl}
                  >
                    <option value="" disabled>New Badge</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              {/* Is Product Event */}
              <Col md={2} lg={3}>
                <Form.Group>
                  <Form.Label style={styles.formLabel}>
                    Outlet Type <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    name="isEventProduct"
                    value={inputData.isEventProduct || ""}
                    onChange={handleChange}
                    style={styles.formControl}
                  >
                    <option value="">Select Outlet Type</option>
                    <option value="false">Regular Outlet</option>
                    <option value="true">Event Outlet</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              {/* Product Tag Name */}
              <Col md={2} lg={3}>
                <Form.Group>
                  <Form.Label style={styles.formLabel}>
                    Product Tag Name <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Product Tag Name"
                    name="productTagName"
                    value={inputData.productTagName || ""}
                    onChange={handleSearchText}
                    style={styles.formControl}
                  />
                  {productTags?.length > 0 && (
                    <div className="dropdown-menu show">
                      {productTags?.map((prod) => (
                        <div
                          key={prod._id}
                          style={styles.dropdownItem}
                          onClick={() => handleOptionSelect(prod._id, prod.tagName)}
                        >
                          {prod.tagName}
                        </div>
                      ))}
                    </div>
                  )}
                </Form.Group>
              </Col>

              {/* Excluded Outlets */}
              <Col md={6} lg={6}>
                <Form.Group>
                  <Form.Label style={styles.formLabel}>Select Excluded Outlets</Form.Label>
                  <Select
                    components={animatedComponents}
                    isMulti
                    placeholder="Select Outlets Which has to be excluded" // You can also use a dynamic placeholder from props or state
                    options={outletData}
                    value={selectedExcludedOutlets}
                    onChange={handleSelectChange}
                    closeMenuOnSelect={false}
                    styles={customStyles}
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        primary25: "#e9ecef",
                        primary: "#007bff",
                      },
                    })}
                  />
                </Form.Group>
              </Col>

              {/* Product Keywords */}
              <Col md={12} lg={6}>
                <Form.Group>
                  <Form.Label style={styles.formLabel}>
                    Nature Of Product{" "}
                    {" "}
                    <span style={styles.helperText}>
                      (Press Enter After Adding Each Keyword)
                    </span>
                  </Form.Label>
                  <TagsInput
                    value={selectedNature}
                    onChange={setSelectedNature}
                    name="keywords"
                    placeHolder="Add Nature Of The Nature"
                  />
                </Form.Group>
              </Col>

              {/* Product Keywords */}
              <Col md={12} lg={6}>
                <Form.Group>
                  <Form.Label style={styles.formLabel}>
                    Product Keywords{" "}
                    <span className="text-danger">*</span>{" "}
                    <span style={styles.helperText}>
                      (Press Enter After Adding Each Keyword)
                    </span>
                  </Form.Label>
                  <TagsInput
                    value={selected}
                    onChange={setSelected}
                    name="keywords"
                    placeHolder="Add keywords"
                  />
                </Form.Group>
              </Col>

              {/* Description */}
              <Col md={12} lg={12}>
                <Form.Group>
                  <Form.Label style={styles.formLabel}>
                    Description <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    placeholder="Description"
                    name="description"
                    value={inputData.description || ""}
                    onChange={handleChange}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>
            </Row>
            <hr />
            <div className='mt-3'>
              <Button className='mb-3' type='submit' variant="primary" disabled={isLoading} style={styles.button}>
                {isLoading ? <Spinner size='sm' /> : "ADD MENU"}
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </React.Fragment>
  )
}

export default AddMenu